<template>
  <div>
    <el-row>
      <el-col :span="18">
        <div class="block">
          <span class="demonstration">时间范围：</span>
          <el-date-picker
            v-model="timeRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="m-ml10"
            @click="handleClick(1)"
            >用户增长率</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <ve-line :data="chartDataTotalCount"></ve-line>
    </el-row>
    <el-row class="m-mt20">
      <ve-line :data="chartDataGrowthCount"></ve-line>
    </el-row>
    <el-row class="m-mt20">
      <ve-line :data="chartDataGrowthRate"></ve-line>
    </el-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      option: {},
      activeName: "first",
      orderBy: "",
      timeRange: [moment().subtract(6, "months"), moment()],
      tableData: [],
      chartheight: "100px",
      chartDataTotalCount: {
        columns: ["日期", "用户总量"],
        rows: [
          /*
          { 日期: "1/1", 用户总量: 1393 },
          { 日期: "1/2", 用户总量: 3530 }
          */
        ]
      },
      chartDataGrowthCount: {
        columns: ["日期", "新增用户"],
        rows: []
      },
      chartDataGrowthRate: {
        columns: ["日期", "增长率"],
        rows: []
      }
    };
  },
  methods: {
    handleClick(dataType) {
      this.$axios(this.$urlMapping["查询用户增长"], {
        data: {
          dateFrom: this.$ToDateString(this.timeRange[0]),
          dateTo: this.$ToDateString(this.timeRange[1]),
          dataType: dataType
        }
      }).then(result => {
        console.log(result);
        // this.tableData = result;
        // //转换数据格式
        let rows1 = result.map(x => {
          return {
            日期: this.$ToDateString(x.date),
            用户总量: x.currentTotalCount
          };
        });
        this.chartDataTotalCount.rows = rows1;
        let rows2 = result.map(x => {
          return {
            日期: this.$ToDateString(x.date),
            新增用户: x.growthCount
          };
        });
        this.chartDataGrowthCount.rows = rows2;
        let rows3 = result.map(x => {
          return {
            日期: this.$ToDateString(x.date),
            增长率: x.growthRate * 100
          };
        });
        this.chartDataGrowthRate.rows = rows3;
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
